var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('v-row',[_c('v-col',{attrs:{"algin":"center"}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/title.png"),"width":"270"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }